import { useEffect, createContext, useState } from 'react'
import { Spin } from 'antd'
import { getAuth, getConfig } from '../lib/allauth'

export const AuthContext = createContext(null)

const loadingStyle = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 18,
  background: '#f7f9fc'
}

export function AuthLoading () {
  return (
    <div style={loadingStyle}>
      <img src='/TTI_logo.svg' alt='TTI Appraisal' style={{ width: 110, height: 110, objectFit: 'contain' }} />
      <Spin size='large' />
    </div>
  )
}

function LoadingError () {
  return <div>Loading error!</div>
}

export function AuthContextProvider (props) {
  const [auth, setAuth] = useState(undefined)
  const [config, setConfig] = useState(undefined)

  useEffect(() => {
    function onAuthChanged (e) {
      setAuth(auth => {
        if (typeof auth === 'undefined') {
          console.log('Authentication status loaded')
        } else {
          console.log('Authentication status updated')
        }
        return e.detail
      }
      )
    }

    document.addEventListener('allauth.auth.change', onAuthChanged)
    getAuth().then(data => setAuth(data)).catch((e) => {
      console.error(e)
      setAuth(false)
    })
    getConfig().then(data => setConfig(data)).catch((e) => {
      console.error(e)
    })
    return () => {
      document.removeEventListener('allauth.auth.change', onAuthChanged)
    }
  }, [])
  const loading = (typeof auth === 'undefined') || config?.status !== 200
  let content = props.children
  if (loading) content = <AuthLoading />
  else if (auth === false) content = <LoadingError />
  return (
    <AuthContext.Provider value={{ auth, config }}>
      {content}
    </AuthContext.Provider>
  )
}
